var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91872 2.54768C6.66561 1.91492 6.05276 1.5 5.37126 1.5H3.07895C2.20692 1.5 1.5 2.20675 1.5 3.07878C1.5 10.491 7.50898 16.5 14.9212 16.5C15.7933 16.5 16.5 15.793 16.5 14.921L16.5004 12.6283C16.5004 11.9468 16.0856 11.334 15.4528 11.0809L13.2558 10.2024C12.6874 9.97509 12.0402 10.0774 11.57 10.4693L11.0029 10.9422C10.3407 11.4941 9.36636 11.4502 8.75683 10.8407L7.16018 9.24255C6.55065 8.63302 6.50561 7.65945 7.05745 6.99724L7.53027 6.43025C7.92218 5.95996 8.02541 5.31263 7.79805 4.74424L6.91872 2.54768Z",
    stroke: "#003057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a4ab22d1f12e3714e7806f273608835f.svg";
export { ForwardRef as ReactComponent };